<template>
  <div class="h-full flex flex-col" @click.self="$emit('close')">

    <slot class="flex-none" name="selected" :component="component" />

    <div class="pbc-links grow overflow-auto">
      <div class="pbc-link" v-for='{name, components} in linkGroups' :key='name'>
        <div class="pbc-link-name">{{name}}</div>
        <div class="pbc-link-components" v-for='fromComponent in components' :key='fromComponent.id'>
          <slot name="from" :component='fromComponent' :has-slots='hasSlots(fromComponent)' />
        </div>
      </div>
      <slot name="after" :component="component" />
    </div>

    <div class="self-end w-32 flex-none" v-for='{component} in toComponents' :key='component.id'>
      <slot name="to" :component='component' />
    </div>


  </div>
</template>
<script>
import SelectedComponentMixin from '@components/selectedComponentMixin.js';
export default {
  mixins: [SelectedComponentMixin],
  components: {
  }
}
</script>
